
import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import tmdbApi from "../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import SessionPopup from "./SessionPopup"
import { useNavigate, Link } from "react-router-dom";
import * as Config from "../constants/Config";
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment";
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';

let { lambda, country, appname } = window.app;


const Profile = () => {
    const navigate = useNavigate();
    const [countries, setCountries] = useState('');
    const [idc, setIdc] = useState('');

    const [image, setImg] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState("");
    const [phonenumber, setPhoneNumber] = useState("");
    const [data, setData] = useState([])
    const [success, setSuccess] = useState(false);
    const [phoneerror, setPhoneError] = useState('');
    const [nameerror, setNameError] = useState('');
    const [formData, setFormData] = useState({});
    const [passwordInput, setPasswordInput] = useState({
        password: '',
        confirmPassword: '',
        oldPassword:''
    })

    const [IdcError, setIdcError] = useState('');

    const [passwordError, setPasswordErr] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [passwordShown, setPasswordShown] = useState(false);
    const [number, setNumber] = useState(false);
    const [upper, setUpper] = useState(false);
    const [limit, setLimit] = useState(false);
    const [lower, setLower] = useState(false);
    const [special, setSpecial] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [defaultCountryCode, setDefaultCountryCode] = useState("");
    const [error, setError] = useState('');
    const [oldPasswordError, setOldPasswordError] = useState("");
    const [loaderEnable, setLoaderEnable] = useState("");
    const [filesData, setFilesData] = useState([]);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [files, setFiles] = useState([]);
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const [hasPasswordChanges, setHasPasswordChanges] = useState(false);
    const [lastEditedSection, setLastEditedSection] = useState(null); // 'profile' or 'password'
    const { welcomeMsg, setWelcomeMsg, GetClientDataContext, uploadLogo, profileData, setprofileData, userData, isUpdated, setIsUpdated, initialProfileData, setInitialProfileData, setUploadLogo } = useContext(contentContext)
    let siteConfig = window?.site?.common;
    let appResourcesUrl = siteConfig?.imageCloudfront;
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        // GetUserData();
        GetCountries();
        userActivity();
        // GetCountries();
    }, []);

    console.log('lastEditedSection', lastEditedSection);

    useEffect(() => {
        const hasUnsavedChanges = isUpdated || hasPasswordChanges;
        window.__HAS_UNSAVED_CHANGES__ = hasUnsavedChanges;

        window.__SHOW_UNSAVED_MODAL__ = (action) => {
            setPendingAction(() => action);
            setShowDiscardModal(true);
        };

        return () => {
            window.__HAS_UNSAVED_CHANGES__ = false;
            window.__SHOW_UNSAVED_MODAL__ = null;
        };
    }, [isUpdated, hasPasswordChanges]);


    // const loginType = localStorage.getItem('login_type');
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    useEffect(() => {
        const hasChanges = passwordInput?.oldPassword !== '' ||
            passwordInput?.password !== '' ||
            passwordInput?.confirmPassword !== '';
        setHasPasswordChanges(hasChanges);
        console.log('password input',passwordInput)
        console.log('hasChanges----------->',hasChanges)

        if (hasChanges) {
            setLastEditedSection('password');
        }
    }, [passwordInput]);
    const guardUnsavedChanges = (action) => {
        const hasUnsavedChanges = isUpdated || hasPasswordChanges;

        if (hasUnsavedChanges) {
            setPendingAction(() => action);
            setShowDiscardModal(true);
        } else {
            action();
        }
    };

    const handleBack = (e) => {
        guardUnsavedChanges(() => {
            navigate(-1);
        });
    };

    const handleDiscardChanges = () => {
        // Reset profile data if profile was edited
        if (lastEditedSection === 'profile') {
            setprofileData(initialProfileData);
            setIsUpdated(false);
        }

        // Reset password fields if password form was edited
        if (lastEditedSection === 'password') {
            setPasswordInput({ oldPassword: '', password: '', confirmPassword: '' });
            setHasPasswordChanges(false);
            // Reset password validation states
            setUpper(false);
            setLower(false);
            setNumber(false);
            setSpecial(false);
            setLimit(false);
            // setPasswordError('');
            setConfirmPasswordError('');
            setOldPasswordError('');
            setError('');
        }

        setShowDiscardModal(false);
        setLastEditedSection(null);

        // Execute pending action if exists
        if (pendingAction) {
            pendingAction();
            setPendingAction(null);
        }
    };

    const handleUpdateFromModal = () => {
        if (lastEditedSection === 'profile') {
            setShowDiscardModal(false);
            handleUserUpdate();
        } else if (lastEditedSection === 'password') {
            setShowDiscardModal(false);
            handlePwdGenerate();
        }
    };
    // console.log("initialDatatatta", initialProfileData)
    useEffect(() => {
        // Helper to safely trim string values
        const trimData = (data) => {
            if (!data || typeof data !== 'object') return '{}'; // Return empty JSON string if invalid
            return JSON.stringify(
                Object.fromEntries(
                    Object.entries(data).map(([key, value]) => [key, value?.trim?.() ?? value])
                )
            );
        };

        // Only run comparison if both are defined
        if (profileData && initialProfileData) {
            const isChanged = trimData(profileData) !== trimData(initialProfileData);
            setIsUpdated(isChanged);
            console.log("ischanged:", isChanged);
        } else {
            // If one or both objects are missing, treat as not updated
            setIsUpdated(false);
            console.warn("profileData or initialProfileData is undefined");
        }
    }, [profileData, initialProfileData]);



    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
   

    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });
            setCountries(response?.result.data);

        } catch {
            console.log("error");
        }
    };
    // console.log("data", data);
    const checkInput = (e) => {
        const onlyDigits = e.target.value.replace(/\D/g, "");
        setPhoneNumber(onlyDigits);

    };

  

    const handleUserUpdate = (e) => {
        let flag = true;
        // if (phonenumber === "") {
        //     setPhoneError("Please enter phone number");
        //     flag = false
        //     setTimeout(function () { setPhoneError("") }, 3000);
        // }
        if (profileData?.name === "") {
            setNameError("Please enter name");
            flag = false
            setTimeout(function () { setNameError("") }, 3000);
        }

        if (profileData?.phone === "") {
            setPhoneError("Enter phone number");
            setTimeout(function () { setPhoneError("") }, 3000);
            flag = false
        } else if (
            (profileData.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(profileData.phone)) ||
            (profileData.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(profileData.phone))
        ) {
            setPhoneError("Invalid phone number format");
            setTimeout(function () { setPhoneError("") }, 3000);
            flag = false


        }

        if (flag) {
            UpdateForm()

        }

    }

    const UpdateForm = async () => {

        setLoaderEnable("updateForm")
        try {
            let response;


            response = await tmdbApi.AdminUpdateApi({
                "name": profileData?.name?.trim(),
                "phone": profileData?.phone?.trim(),

                "idc": profileData?.idc
            });


            if (response?.statusCode === 200) {
                if (response?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setToastMessage("Updated successfully")

                    GetClientDataContext()
                    setLoaderEnable("")
                    setInitialProfileData(profileData);
                    setIsUpdated(false);
                    setShowDiscardModal(false);
                    if (pendingAction) {
                        setShowDiscardModal(false);
                        pendingAction();
                        setPendingAction(null);
                    }
                }
            }
        } catch {
            console.log("error");
        }
    };

    function onConfirm() {
        setSuccess(false)
    };

    const handlePwdGenerate = (e) => {

        if (passwordInput?.password === "") {
            setError("Please Enter Password");
            setTimeout(function () { setError("") }, 3000);

        } else if (passwordInput?.confirmPassword === "") {
            setError("Please Enter Confirm Password");
            setTimeout(function () { setError("") }, 3000);

        } else if (passwordInput?.oldPassword === "") {
            setError("Please Enter Old Password");
            setTimeout(function () { setError("") }, 3000);

        }
        else if (passwordInput?.confirmPassword !== passwordInput?.password) {
            setConfirmPasswordError("Confirm password is not matched");
            setTimeout(function () { setConfirmPasswordError("") }, 3000);
        }


        else if (!limit || !upper || !special || !lower || !number) {
            console.log('adsfadsf')
            setError("Please enter the password as per the instructions");
            // setTimeout(function () { setError("") }, 3000);

        }
        else if (limit && upper && special && lower && number && confirmPasswordError === "") {
            setError("")
            if (passwordInput?.password === passwordInput?.confirmPassword) {
                setConfirmPasswordError("")
                pwdGenerate();
            }
        }

    }

    const pwdGenerate = async () => {
        let response;
        setLoaderEnable("pwdGenerate")
        try {

            response = await tmdbApi.UserPwdGenerate({
                // "emailid": email,
                "newPassword": passwordInput?.password,
                "oldPassword": passwordInput?.oldPassword
            });


            console.log(response);


            if (response?.statusCode === 200) {


                if (response?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else if (response?.result === "old password is wrong") {
                    setOldPasswordError("old password is incorrect");
                    setLoaderEnable("")
                } else {
                    // setSuccess(true);
                    setToastMessage("Updated successfully");
                    setPasswordInput({ ...passwordInput, password: '', confirmPassword: '', oldPassword: '' })
                    setLoaderEnable("")
                    setHasPasswordChanges(false);
                    setLastEditedSection(null);


                    if (pendingAction) {
                        setShowDiscardModal(false);
                        pendingAction();
                        setPendingAction(null);
                    }
                }

            }


        } catch {
            console.log("error");
        }
    };

    const handlePasswordChange = (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
        setPasswordInput(NewPasswordInput);

    }
    const togglePassword = (e) => {
        setPasswordShown(!passwordShown);
    };

    const handleValidation = (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        //for password 
        if (passwordInputFieldName === 'password' || passwordInputFieldName === 'oldPassword') {
            const uppercaseRegExp = /(?=.*?[A-Z])/;
            const lowercaseRegExp = /(?=.*?[a-z])/;
            const digitsRegExp = /(?=.*?[0-9])/;
            const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
            const minLengthRegExp = /.{8,}/;
            const passwordLength = passwordInputValue.length;
            const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
            const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
            const digitsPassword = digitsRegExp.test(passwordInputValue);
            const specialCharPassword = specialCharRegExp.test(passwordInputValue);
            const minLengthPassword = minLengthRegExp.test(passwordInputValue);
            let errMsg = "";
            if (passwordLength === 0) {
                errMsg = "Password is empty";
            }

            if (uppercasePassword) {
                var element = document.getElementById("err1");
                element?.classList?.add("vaild");
                setUpper(true);
            } else {
                var element = document.getElementById("err1");
                element?.classList?.remove("vaild");
                setUpper(false);
            }
            if (lowercasePassword) {
                var element = document.getElementById("err");
                element?.classList?.add("vaild");
                setLower(true);
            } else {
                var element = document.getElementById("err");
                element?.classList?.remove("vaild");
                setLower(false);
            }
            if (digitsPassword) {
                var element = document.getElementById("err2");
                element?.classList?.add("vaild");
                setNumber(true);
            } else {
                var element = document.getElementById("err2");
                element?.classList?.remove("vaild");
                setNumber(false);
            }
            if (specialCharPassword) {
                var element = document.getElementById("err3");
                element?.classList?.add("vaild");
                setSpecial(true)
            } else {
                var element = document.getElementById("err3");
                element?.classList?.remove("vaild");
                setSpecial(false)
            }
            if (minLengthPassword) {
                var element = document.getElementById("err4");
                element?.classList?.add("vaild");
                setLimit(true)
            } else {
                var element = document.getElementById("err4");
                element?.classList?.remove("vaild");
                setLimit(false)
            }

            if (limit && upper && special && lower && number && confirmPasswordError === "") {
                setError("")
            }
            setPasswordErr(errMsg);
        }
 

    }
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state
        setLastEditedSection('profile');
        setprofileData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));

    };
    // console.log("profileDatatatatatatta", profileData)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setLastEditedSection('profile');
        if (name === "name") {
            setprofileData(prev => ({
                ...prev,
                [name]: value
            }));
        }
        else if (name === "idc") {
            setprofileData(prev => ({
                ...prev,
                [name]: value
            }));
        }
        else if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = profileData?.idc?.trim(); // Directly get the latest idc value

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            }
            else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            setprofileData(prev => ({ ...prev, [name]: formattedValue }));
        }
    };

    const handleAddclass = (evnt) => {
        var element = document.getElementById("instruction");
        element?.classList?.add("ins-dsp-none");
        setConfirmPasswordError("");
    }
    const handleRemoveclass = (evnt) => {
        var element = document.getElementById("instruction");
        element?.classList?.remove("ins-dsp-none");
    }
    const handleConfirm = (evnt) => {
        const passwordInputFieldName = evnt.target.name;
        if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {

   

        }
    }

    const RemoveError = () => {
        setOldPasswordError("");
    }


    useEffect(() => {
        myArray = localStorage.getItem("ClientName")?.split(" ");


    }, [localStorage.getItem("ClientName")]);

    let myArray = []
    myArray = localStorage.getItem("ClientName")?.split(" ");

    let k = countries && countries?.length > 0 && countries?.filter(eachItem => eachItem.alpha2 === defaultCountryCode)
    return (
        <>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <Modal className="access-denied" show={showDiscardModal} centered>
                    <div className="modal-body enquiry-form">
                        <div className="container">
                            <button
                                className="close-btn"
                                onClick={() => setShowDiscardModal(false)}
                            >
                                <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                                warning
                            </span>

                            <h3>Unsaved Changes</h3>
                            <p>
                                You have unsaved changes in {lastEditedSection === 'profile' ? 'User Details' : 'Change Password'}.<br />
                                Do you want to discard them or update?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                                <button
                                    className="fill_btn"
                                    onClick={handleDiscardChanges}
                                >
                                    Discard
                                </button>

                                <button
                                    className="fill_btn yellow-gradient"
                                    onClick={handleUpdateFromModal}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <div className="main-content edit-content user-management profile" id="user-profile-section">

                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">
                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="profile-title">Profile</h4>

                                        </div>
                                        <div>
                                            <a onClick={handleBack} className="stroke-btn-style"><span className="material-symbols-outlined">arrow_back</span>Back</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="create-user-block" id="create-user-block">
                                <div className="form-block" id="form-block">
                                    <div className="row">
                                        <div className="col-md-7 user-details" id="user-details">
                                            <h3 id="user-details-title">User Details</h3>
                                            <div className="mb-3 row" id="name-row">
                                                <div className="col-md-12">
                                                    <label for="name-input" className="col-form-label">NAME</label>
                                                    <input className="form-control" placeholder="Enter Name" type="text" name="name" value={profileData?.name} onChange={handleChange} id="name-input" />
                                                </div>
                                                {nameerror ? <span className="errormsg" id="name-error" style={{ fontWeight: 'bold', color: 'red' }}>{nameerror}</span> : ""}
                                            </div>
                                            <div className="mb-3 row" id="email-row">
                                                <div className="col-md-12">
                                                    <label for="email-input" className="col-form-label">E MAIL ID</label>
                                                    <input className="form-control contact-number" type="email" value={profileData?.emailid} placeholder="Enter Company Email" id="email-input" disabled />
                                                </div>
                                            </div>
                                            <div className="mb-3 row" id="phone-number-row">
                                                <div className="col-md-12">
                                                    <label for="phone-input" className="col-form-label">PHONE NUMBER</label>
                                                    <div className="country-code" id="country-code-block">
                                                        <select name="idc" value={profileData?.idc} className="colorselect capitalize" onChange={handleCountryChange} id="country-code-select">
                                                            <option value="">Select</option>
                                                            {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                return (
                                                                    <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                                )
                                                            }
                                                            )}
                                                        </select>
                                                        <input className="form-control contact-number" type="tel" value={profileData?.phone} name="phone" onChange={handleChange} placeholder="Phone number" id="phone-input" />
                                                    </div>
                                                    <span className="errormsg" id="country-code-error" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                                    {phoneerror ? <span className="errormsg" id="phone-error" style={{ fontWeight: 'bold', color: 'red' }}>{phoneerror}</span> : ""}
                                                </div>
                                            </div>


                                            <div className="mb-3 row" id="update-button-row">
                                                <div className="col-md-12">
                                                    <button onClick={handleUserUpdate} className={` ${!isUpdated ? "disable fill-btn-style" : "fill-btn-style"}`} id="update-button" disabled={!isUpdated || loaderEnable === "updateForm"}>
                                                        {loaderEnable === "updateForm" ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />) : null}
                                                        UPDATE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-5 prfile-block" id="profile-block">
                                            <div className="avatar-block" id="avatar-block">
                                                <div className="avatar-header" id="avatar-header">
                                                    <div className="avatar-img-block" id="avatar-img-block">
                                                        <p id="avatar-initials">
                                                            {myArray?.length > 1 ? (
                                                                (myArray[0]?.charAt(0) || "").toUpperCase() +
                                                                (myArray[1]?.charAt(0) || "").toUpperCase()
                                                            ) : (
                                                                (userData?.name?.slice(0, 2) || "")
                                                            )}
                                                        </p>

                                                    </div>
                                                </div>
                                                <div className="avatar-body" id="avatar-body">
                                                    <h6 className="username mt-3" id="username">{userData?.name}</h6>
                                                    <p className="lg-badge badge" id="user-type">{userData?.type}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="create-user-block create-pwd-block" id="password-change-section">
                                <div className="form-block" id="password-change-form">
                                    <h3 id="password-change-title">Change Password</h3>
                                    <div className="row">
                                        <div className="col-md-7">
                                            <div className="mb-3 row">
                                                <div className="col-md-12 mb-3">
                                                    <label className="floatingInput">Old Password<span>*</span></label>
                                                    <input type={passwordShown ? "text" : "password"} value={passwordInput?.oldPassword} onChange={(e) => handlePasswordChange(e)} name="oldPassword" placeholder="Old Password" className="form-control" onFocus={RemoveError}
                                                        id="old-password-input"

                                                    />
                                                    <p className="text-danger" id="old-password-error">{oldPasswordError}</p>
                                                </div>

                                                <div className="col-md-12 mb-3">
                                                    <label className="floatingInput">New Password<span>*</span></label>
                                                    <input type={passwordShown ? "text" : "password"} value={passwordInput?.password} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleValidation} name="password" placeholder="Password" className="form-control" onBlur={(e) => { handleAddclass(e) }}
                                                        onFocus={(e) => { handleRemoveclass(e) }}
                                                        id="new-password-input"

                                                    />
                                                    <p className="text-danger" id="new-password-error">{passwordError}</p>
                                                </div>



                                                <div className="col-md-12 mb-3">
                                                    <label className="floatingInput">Confirm Password<span>*</span></label>
                                                    <input type={passwordShown ? "text" : "password"} value={passwordInput?.confirmPassword} onChange={(e) => handlePasswordChange(e)} onKeyUp={handleConfirm} onBlur={(e) => { handleAddclass(e) }} onFocus={(e) => { handleRemoveclass(e) }} name="confirmPassword" placeholder="Password" className="form-control" id="confirm-password-input" />
                                                    <p className="text-danger" id="confirm-password-error">{confirmPasswordError}</p>


                                                </div>


                                                <div className="col-md-12 mb-3">
                                                    <div className="flex-left terms-block"> <input type="checkbox" id="terms-check" onChange={(e) => togglePassword(e)} /><label>Show Password</label></div>
                                                </div>

                                                <p className="text-danger" id="password-general-error">{error}</p>

                                                <div className="col-md-12">
                                                    <button className="fill-btn-style" id="update-password-btn" onClick={e => handlePwdGenerate(e)}>{loaderEnable === "pwdGenerate" ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />) : null}UPDATE</button>

                                                </div>
                                            </div>
                                            <div className="create-password-instruction ins-dsp-none" id="instruction">
                                                <p className="error" id="err">{lower ? <span className="material-symbols-outlined">
                                                    check
                                                </span> : <span className="material-symbols-outlined">
                                                    close
                                                </span>} Password must contain a lower case letter</p>
                                                <p className="error" id="err1"> {upper ? <span className="material-symbols-outlined">
                                                    check
                                                </span> : <span className="material-symbols-outlined">
                                                    close
                                                </span>} Password must contain an upper case letter</p>
                                                <p className="error" id="err2">  {number ? <span className="material-symbols-outlined">
                                                    check
                                                </span> : <span className="material-symbols-outlined">
                                                    close
                                                </span>} Password must contain a number</p>
                                                <p className="error" id="err3"> {special ? <span className="material-symbols-outlined">
                                                    check
                                                </span> : <span className="material-symbols-outlined">
                                                    close
                                                </span>} Password must contain a special character or a space</p>
                                                <p className="error" id="err4"> {limit ? <span className="material-symbols-outlined">
                                                    check
                                                </span> : <span className="material-symbols-outlined">
                                                    close
                                                </span>} Password must contain at least 8 characters</p>
                                            </div>
                                        </div>

                                    </div>



                                </div>
                            </div>




                        </div>
                    </div>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="Ok"
                        confirmBtnBsStyle="primary"
                        title={"Updated successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>

                    <Footer />
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                        id="toastContainer"
                    />
                </div>


            </div>

        </>
    );
};

export default Profile;
